module.exports = __webpack_public_path__ + "img/img2.4796a0de.png";